import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
import { WarpRing } from './WarpRing';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from '../i18n/translations';
export function HeroSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].hero;
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-135">
      {/* Background Stars/Particles */}
      <div className="absolute inset-0 z-0" data-id="element-136">
        {[...Array(20)].map((_, i) => <div key={i} className="absolute bg-white rounded-full opacity-20 animate-pulse" style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 3 + 1}px`,
        height: `${Math.random() * 3 + 1}px`,
        animationDelay: `${Math.random() * 5}s`
      }} data-id="element-137" />)}
      </div>

      <div className="container mx-auto px-4 z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-138">
        {/* Text Content */}
        <div className="text-center lg:text-left space-y-6 order-2 lg:order-1" data-id="element-139">
          <div className="inline-block px-4 py-1 rounded-full border border-[#00c9a7]/30 bg-[#00c9a7]/10 backdrop-blur-sm mb-4" data-id="element-140">
            <span className="text-[#00f5a0] text-sm font-semibold tracking-wider" data-id="element-141">
              {t.available}
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight" data-id="element-142">
            {t.titleLine1} <br data-id="element-143" />
            <span className="text-gradient" data-id="element-144">{t.titleLine2}</span>
          </h1>

          <h2 className="text-xl md:text-2xl text-gray-300 font-light" data-id="element-145">
            {t.subtitle}{' '}
            <span className="text-[#00c9a7] italic" data-id="element-146">{t.subtitleHighlight}</span>
            .
          </h2>

          <p className="text-gray-400 max-w-lg mx-auto lg:mx-0 text-lg" data-id="element-147">
            {t.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4" data-id="element-148">
            <Button size="lg" rightIcon={<ArrowRight size={18} data-id="element-150" />} onClick={() => document.getElementById('projects')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-149">
              {t.viewWork}
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-151">
              {t.getInTouch}
            </Button>
          </div>
        </div>

        {/* Visual Content */}
        <div className="flex items-center justify-center order-1 lg:order-2 relative" data-id="element-152">
          <WarpRing data-id="element-153" />
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce text-gray-500" data-id="element-154">
        <ChevronDown size={32} data-id="element-155" />
      </div>
    </section>;
}